import { Link } from "react-router-dom";
import { SocialLinks, useSettings } from "@/context/SettingsContext";
import { Wordmark } from "@/components/brand/Wordmark";
import { Marquee } from "@/components/Marquee";
import { Peace, SusCrew } from "@/components/brand/Doodles";

const Contact = () => {
  const { contact_email: e } = useSettings();
  return e ? <li><a href={`mailto:${e}`} className="label font-bold text-cloud/80 transition-colors hover:text-lime" data-testid="footer-link-contact">Contact</a></li> : null;
};
const LINKS = [["/shop", "Shop"], ["/drops", "Drops"], ["/sus-of-the-month", "Sus of the Month"], ["/lookbook", "Lookbook"], ["/about", "About"], ["/about#faq", "FAQ"]];

export const Footer = () => (
  <footer className="bg-ink text-cloud" data-testid="site-footer">
    <div className="tri-stripe" data-testid="footer-tri-stripe" aria-hidden="true" />
    <Marquee />
    <div className="mx-auto grid max-w-[1440px] items-center gap-10 px-5 py-14 sm:px-10 lg:grid-cols-[1fr_auto_1fr]">
      <div className="flex items-end gap-8 justify-self-start">
        <Link to="/" aria-label="the suspects home"><Wordmark dark variant="stacked" size="lg" /></Link>
        <SusCrew className="mb-1 text-lg text-cloud/70" />
        <Peace size={34} className="mb-1 text-cloud/70" />
      </div>
      <nav aria-label="Footer">
        <ul className="flex flex-wrap gap-x-8 gap-y-3">
          {LINKS.map(([to, l]) => (
            <li key={l}><Link to={to} className="label font-bold text-cloud/80 transition-colors hover:text-pink" data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</Link></li>
          ))}
          <li><Link to="/order-lookup" className="label font-bold text-cloud/80 transition-colors hover:text-pink" data-testid="footer-link-order-lookup">Order lookup</Link></li>
          <Contact />
        </ul>
      </nav>
      <div className="flex items-center gap-6 lg:justify-self-end">
        <SocialLinks linkClass="text-cloud/70 transition-colors hover:text-sky" />
        <span className="label text-cloud/60">Toronto, Canada</span>
      </div>
    </div>
    <div className="border-t border-cloud/10">
      <div className="mx-auto flex max-w-[1440px] flex-col justify-between gap-2 px-5 py-5 font-mono text-[10px] uppercase tracking-[0.2em] text-cloud/40 sm:flex-row sm:px-10">
        <span>© {new Date().getFullYear()} the suspects. Good people. Sus ideas.</span>
        <span>Toronto, CA | Est. 2024</span>
      </div>
    </div>
  </footer>
);
